import classnames from 'classnames';
import React from 'react';
import styles from './scrollbar-wrapper.scss';
const ScrollbarWrapper = _ref => {
  let {
    className,
    dataHook,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: classnames(styles['scrollbar-wrapper'], className)
  }, children);
};
export default ScrollbarWrapper;
//# sourceMappingURL=scrollbar-wrapper.js.map